/**
 * 一些拦截器的拓展，用于业务请求的 拦截->操作
 */
import router from '@/router/router';
import { getQueryObj } from '@/util/bom';

const uniformRedirect = (status, code, qcTaskId) => {
  if (status === 200 && code === 101) {
    let pageQuery = getQueryObj();
    setTimeout(() => {
      router.push({
        path: '/qc/flow/uniform-check/' + pageQuery?.orderId,
        query: {
          slan: pageQuery?.slan,
          tlan: pageQuery?.tlan,
          taskId: qcTaskId ? qcTaskId : pageQuery?.qcTaskId,
        },
      });
    }, 200);
  }
};

export default (httpRes) => {
  const status = Number(httpRes.status) || 200;
  const code = httpRes.data?.code;
  const qcTaskId = httpRes.data?.data;

  uniformRedirect(status, code, qcTaskId);
};
